import type { VoteData } from '@library/types/polls';

export interface PollsTableRowProps {
  vote: VoteData;
}

export const MemberPollsRow = ({ vote }: PollsTableRowProps) => {
  const { question, options, selection, winner } = vote;

  return (
    <div className="border-soFresh-140 hover:bg-soFresh-120 text-soClean-110 flex min-h-16 w-full items-center justify-start border-b text-start xl:text-xs">
      <p
        className="line-clamp-2 w-1/4 max-w-[25%] overflow-hidden text-ellipsis px-3"
        data-testid="vote-question"
      >
        {question}
      </p>
      <div
        className="line-clamp-2 w-1/4 max-w-[25%] overflow-hidden text-ellipsis px-3"
        data-testid="vote-options"
      >
        {options?.map((option) => {
          const { answer, id } = option;
          return (
            <p key={id}>
              <span>{answer}</span>
            </p>
          );
        })}
      </div>
      <p className="w-1/4 max-w-[25%] px-3" data-testid="vote-selection">
        {selection}
      </p>
      <p className="w-1/4 max-w-[25%] px-3" data-testid="vote-winner">
        {winner || 'Not Settled'}
      </p>
    </div>
  );
};
